import { gql } from "@apollo/client";
export default gql`
  mutation QueueDownloads($input: QueueDownloadsInput!) {
    queueDownloads(input: $input)
  }
`;
